"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("path", {
  d: "M23.61 17.14a1.28 1.28 0 0 0 .3-1.38 1.23 1.23 0 0 0-1.17-.76h-2.5a.25.25 0 0 1-.23-.15l-1.34-3.12a1.29 1.29 0 0 0-2.3 0L15 14.85a.25.25 0 0 1-.23.15h-2.5a1.24 1.24 0 0 0-1.17.76 1.28 1.28 0 0 0 .3 1.38l2.22 2a.26.26 0 0 1 .06.29l-1.23 2.81a1.26 1.26 0 0 0 .32 1.45 1.28 1.28 0 0 0 1.51.17l3.11-1.75a.21.21 0 0 1 .24 0l3.12 1.75a1.27 1.27 0 0 0 1.5-.17 1.24 1.24 0 0 0 .32-1.45l-1.24-2.84a.26.26 0 0 1 .07-.29Z"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M2.5 2h4.57a.5.5 0 0 1 .45.28l.81 1.62A2 2 0 0 0 10.12 5H19a.5.5 0 0 1 .5.5v3.95a.49.49 0 0 0 .18.37 3.35 3.35 0 0 1 .76 1l.56 1.11a.29.29 0 0 0 .52-.2V5a2 2 0 0 0-2-2h-9.09a.5.5 0 0 1-.43-.28L9.17 1.1A2 2 0 0 0 7.38 0H2a2 2 0 0 0-2 2v14.5a2 2 0 0 0 2 2h7.43a.25.25 0 0 0 .21-.38 3.41 3.41 0 0 1-.59-1.41.25.25 0 0 0-.24-.21H2.5A.5.5 0 0 1 2 16V2.5a.5.5 0 0 1 .5-.5Z"
})), 'FolderStar');

exports.default = _default;